import { Client, User, UserRole } from '@mi-front/core';

export type ImpersonationUserGroupKey = 'mediainbox' | 'client_admin' | 'client_user';

const GROUP_ORDER: Record<ImpersonationUserGroupKey, number> = {
  mediainbox: 0,
  client_admin: 1,
  client_user: 2,
};

/**
 * Returns the group key for a user in the impersonation autocomplete.
 * - Mediainbox: email contains @mediainbox
 * - Client admin: role is CLIENT_ADMIN (and not mediainbox)
 * - Client user: rest
 */
export function getImpersonationUserGroupKey(
  user: User & { client?: Client | null },
): ImpersonationUserGroupKey {
  const email = (user.email ?? '').toLowerCase();
  if (email.includes('@mediainbox')) {
    return 'mediainbox';
  }
  if (user.role === UserRole.CLIENT_ADMIN) {
    return 'client_admin';
  }
  return 'client_user';
}

/**
 * Returns the sort order index for a group (lower = first in list).
 */
export function getImpersonationGroupOrder(key: ImpersonationUserGroupKey): number {
  return GROUP_ORDER[key];
}
